<template>
  <div>
    <div class="card-body">
      <div class="row height100" v-if="func_attr_list!==undefined">
        <div class="col-lg-6  h-30">
          <div>
            <div class="card-header bg-info2 text-white">功能组信息</div>
            <div style="">
              <el-form class="form mt-3" @submit.native.prevent
                       style="height: 600px">
                <div class="h-30">
                  <div class=" row mb-2">
                    <label class="col-sm-4  text-lr lh40">功能组名称：</label>
                    <div class="col-sm-7 flex1 lh35">
                      <el-input style="margin-bottom: 0px;width: 220px"
                                v-model=" func_attr_list.name "
                                placeholder="请输入内容"></el-input>
                    </div>
                  </div>
                  <div class=" row mb-2"><label class="col-sm-4  text-lr lh40">平台列表：</label>
                    <div class="col-sm-7 ">
                      <el-select v-model="plat_name" multiple placeholder="请选择" @change="get_plat_data"
                                 value-key="id">
                        <el-option
                            v-for="item in plat_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div v-for="(item,index) in func_attr_list.static_attribute" :key="index">
                    <equip_attr_temp
                        :Data="{'data':item,'attr':{'oneIndex':index,'type':'1','objType':'funcGrounp'}}"
                    ></equip_attr_temp>
                  </div>
                  <div v-if="province_flag">
                    <select_tree :Data="{'data':province_list,'attr':{'id':'code','children':'children','label':'name'
                                  ,'c_priority':'M','func':'func_data',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,'title':'功能组可用省',
                                   'checked_list':provinceId,'name':null,'list':provinceId}}"
                                 @func_data="choice_province"></select_tree>
                  </div>
                  <div v-if="city_flag">
                    <select_tree :Data="{'data':city_list,'attr':{'id':'code','children':'children','label':'name'
                                  ,'c_priority':'M','func':'func_data',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,'title':'功能组可用市',
                                   'checked_list':cityId,'name':null,'list':cityId}}"
                                 @func_data="choice_city"></select_tree>
                  </div>
                  <div v-if="county_flag">
                    <select_tree :Data="{'data':county_list,'attr':{'id':'code','children':'children','label':'name'
                                  ,'c_priority':'M','func':'func_data',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,'title':'功能组可用区县',
                                   'checked_list':countyId,'name':null,'list':countyId}}"
                                 @func_data="choice_county"></select_tree>
                  </div>


                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="col-lg-6  h-30">
          <div>
            <div class="card-header bg-info2 text-white">配置信息</div>
            <div class="row p-3">
              <div class="col-lg-12">
                <div>
                    <span v-if="func_flag">
                      <select_tree :checkAll="true" :Data="{'data':func_list,'attr':{'id':'id','children':'children','label':'chinese_name'
                                  ,'c_priority':'M','func':'func_data',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,'title':'选择功能模块',
                                   'checked_list':func_checked,'name':null,'list':func_checked}}"
                                   @func_data="get_func_data"></select_tree>
                       <select_tree :checkAll="true" :Data="{'data':auth_list,'attr':{'id':'id','children':'children','label':'name','c_priority':'M',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':false,'vuex_commit':true,'title':'选择权限',
                                   'checked_list':auth_checked,'name':null,'list':auth_checked,'func':'auth_data'}}"
                                    @auth_data="get_auth_data"></select_tree>
                         <select_tree :checkAll="true" :Data="{'data':func_type_list,'attr':{'id':'code','children':'children','label':'name','c_priority':'M',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,'title':'功能组可用类型',
                                   'checked_list':link_building_category,'name':null,'list':link_building_category,'func':'type_data'}}"
                                      @type_data="get_type_data"></select_tree>
                    </span>
                  <div class=" row mb-2"><label class="col-sm-4  text-lr lh40">用户列表：</label>
                    <div class="col-sm-7 ">
                      <el-checkbox-group v-model="link_user" @change="get_user_data">
                        <el-checkbox :label="value.id" v-for="(value,index) in options" :key="index"
                        >{{ value.name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import select_tree from "@/components/IBMS/function/general_func_group/tree.vue";
import equip_attr_temp from "@/components/IBMS/function/special_func_group/equip_attr_temp";

export default {
  name: "funcGrounp_dia",
  components: {
    equip_attr_temp,
    select_tree
  },
  props: [
    'Data'
  ],
  data() {
    return {
      func_attr_list: this.$store.state.funcGroup_data,
      checked_list: [],
      flag: true,
      type: 0,
      check_flag: true,
      role_id: this.$store.state.role_id,
      user_list: [],
      func_flag: false,
      checkList: this.$store.state.func_user,
      auth_checked: [],
      func_checked: [],
      props: {
        label: 'name',
        id: 'id',
      },
      loading: false,
      tree_flag: true,
      options: [],
      link_user: this.$store.state.funcGroup_data.link_global_user,
      plat_list: [],
      plat_name: this.$store.state.funcGroup_data.link_platform,
      func_list: [],
      auth_list: [],
      link_building_category: this.$store.state.funcGroup_data.link_building_category,
      province_list: [],//省列表
      city_list: [],//市列表
      county_list: [],//区县列表
      provinceName: '',
      cityName: '',
      countyName: '',
      provinceId: '',
      cityId: '',
      countyId: '',
      temp_list: [],
      temp_list2: [],
      temp_list3: [],
      province_flag: true,
      city_flag: true,
      county_flag: true,
      func_type_list: [],
      // pro_flag:true,
    }
  },
  created() {
    if (JSON.stringify(this.$store.state.funcGroup_data.model) === '{}') {
      this.func_checked = []
    } else {
      this.func_checked = this.$store.state.funcGroup_data.model
    }
    if (JSON.stringify(this.$store.state.funcGroup_data.permission) === '{}') {
      this.auth_checked = []
    } else {
      this.auth_checked = this.$store.state.funcGroup_data.permission
    }

    console.log(this.$store.state.funcGroup_data, 'dsf')
    this.query_role_to_user()
    this.qurey_platform()
    this.query_role_to_func_auth()
    this.query_type_list()
    this.query_province()
    //编辑时

    // if(this.$store.state.funcGroup_data.static_attribute[1].c_value!==null){
    //   this.provinceId=this.$store.state.funcGroup_data.static_attribute[1].c_value
    //   this.query_city()
    // }
    // if(this.$store.state.funcGroup_data.static_attribute[2].c_value!==null){
    //   this.cityId=this.$store.state.funcGroup_data.static_attribute[2].c_value
    //   this.query_county()
    // }
    // if(this.$store.state.funcGroup_data.static_attribute[3].c_value!==null){
    //   this.countyId=this.$store.state.funcGroup_data.static_attribute[3].c_value
    // }
    for (let i in this.$store.state.funcGroup_data.static_attribute) {
      if (this.$store.state.funcGroup_data.static_attribute[i].c_code === '200003') {
        this.provinceId = this.$store.state.funcGroup_data.static_attribute[i].c_value
        this.query_city()
      }
      if (this.$store.state.funcGroup_data.static_attribute[i].c_code === '200004') {
        this.cityId = this.$store.state.funcGroup_data.static_attribute[i].c_value
        this.query_county()
      }
      if (this.$store.state.funcGroup_data.static_attribute[i].c_code === '200005') {
        this.countyId = this.$store.state.funcGroup_data.static_attribute[i].c_value
        // this.query_county()
      }
    }
  },
  methods: {
    query_type_list() {
      this.func_type_list = []
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/QueryFuncGroupTypeList',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {}
        },
      }).then((response) => {
        if (response.data.result === 200) {
          // this.func_type_list=response.data.content.func_group_name_list
          for (let i in response.data.content.func_category_name_list) {
            // for (let x in response.data.content.func_category_name_list[i].category_name_list) {
            this.func_type_list.push({
              'name': response.data.content.func_category_name_list[i].func_category_name,
              'id': response.data.content.func_category_name_list[i].id
            })
            // }
          }
        }
      })
    },
    //选择的区县
    choice_county(data) {
      this.countyId = data
      for (let i in this.$store.state.funcGroup_data.static_attribute) {
        if (this.$store.state.funcGroup_data.static_attribute[i].c_code === '200005') {
          this.$store.state.funcGroup_data.static_attribute[i].c_value = this.countyId
        }
      }
    },
    //选择的市
    choice_city(data) {
      this.cityId = data
      for (let i in this.$store.state.funcGroup_data.static_attribute) {
        if (this.$store.state.funcGroup_data.static_attribute[i].c_code === '200004') {
          this.$store.state.funcGroup_data.static_attribute[i].c_value = this.cityId
        }
      }
      this.query_county()
    },
    //选择的省
    choice_province(data) {
      this.provinceId = data
      for (let i in this.$store.state.funcGroup_data.static_attribute) {
        if (this.$store.state.funcGroup_data.static_attribute[i].c_code === '200003') {
          this.$store.state.funcGroup_data.static_attribute[i].c_value = this.provinceId
        }
      }
      this.query_city()
    },
    //选择的平台
    get_plat_data(data) {
      this.$store.state.funcGroup_data.link_platform = data
    },
    //选择的功能模块
    get_func_data(data) {
      this.$store.state.funcGroup_data.model = data
    },
    //选择的权限
    get_auth_data(data) {
      this.$store.state.funcGroup_data.permission = data
    },
    get_type_data(data) {
      console.log(data, '45fff')
      this.$store.state.funcGroup_data.link_building_category = data

    },
    //查询平台
    qurey_platform() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": '10'
        },
      }).then((res) => {
        console.log(res)
        this.plat_list = res.data.content.data
      })
    },
    //选择的用户
    get_user_data(data) {
      this.$store.state.funcGroup_data.link_global_user = data
    },
    //查询省
    query_province() {
      this.province_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'Common/Province',
        data: {
          "data": {}
        },
      }).then((res) => {
        for (let i in res.data.content) {
          this.province_list.push({'id': res.data.content[i].code, 'name': res.data.content[i].name})
        }
        this.province_flag = true
      })
    },
    //查询市
    query_city() {
      this.city_flag = false
      this.city_list = []
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'Common/City',
        data: {
          "data": {
            "id_list": this.provinceId
          }
        },
      }).then((res) => {
        console.log(res)
        for (let i in res.data.content) {
          this.city_list.push({
            "id": res.data.content[i].code, 'name': res.data.content[i].name,
            'disabled': true, 'children': []
          })
          for (let x in res.data.content[i].children) {
            this.city_list[i].children.push({
              "id": res.data.content[i].children[x].code, 'name': res.data.content[i].children[x].name,

            })
          }
        }
        this.city_flag = true
      })
    },
    //查询区县
    query_county() {
      this.county_flag = false
      this.county_list = []
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'Common/County',
        data: {
          "data": {
            "id_list": this.cityId
          }
        },
      }).then((res) => {
        console.log(res)
        for (let i in res.data.content) {
          this.county_list.push({
            "id": res.data.content[i].code, 'name': res.data.content[i].name,
            'disabled': true, 'children': []
          })
          for (let x in res.data.content[i].children) {
            this.county_list[i].children.push({
              "id": res.data.content[i].children[x].code, 'name': res.data.content[i].children[x].name,

            })
          }
        }

        this.county_flag = true
      })
    },
    //查询角色下级关联所有用户(面板用户列表)
    query_role_to_user() {
      this.user_list = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          object_code: '10',
          need_user_tree: '1',
        },
      }).then((response) => {
        // var arry=[{'id':'','name':'未分级用户','children':response.data.content[1].user_list}]
        // var list = this.r_user(response.data.content[0])
        this.options = response.data.content[0].user_list

      })
    },
    //查询角色关联功能及权限
    //type:2:当前角色关联功能权限树，1：选中角色关联功能及权限id查询
    query_role_to_func_auth() {
      this.func_flag = false
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          'object_code': '63',
        }
      }).then((response) => {
        for (let i in response.data.content) {
          this.func_list.push({
            'id': response.data.content[i].id, 'name': response.data.content[i].name,
            'chinese_name': response.data.content[i].chinese_name
          })
        }
        for (let i in response.data.content) {
          this.auth_list.push({
            'id': response.data.content[i].id,
            'name': response.data.content[i].chinese_name,
            'disabled': true,
            'children': []
          })
          if (response.data.content[i].children.length!==0) {
          for (let x in response.data.content[i].children) {
            this.auth_list[i].children.push(
                {
                  'id': response.data.content[i].children[x].id,
                  'name': response.data.content[i].children[x].chinese_name,
                  'children': []
                }
            )
          }
          this.auth_list = this.auth_list.filter(i => i.children.length>0)
        }}
        this.func_flag = true
        // console.log(this.auth_list, this.func_list, 'auth_list')
      })
    },
  }
}
</script>

<style scoped>

.el-tree-node__content > label.el-checkbox {
  margin-right: 8px;
  padding-top: 10px !important;
}
</style>